import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function HaftungsausschlussPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="py-16 md:py-24 bg-white" data-id="element-409">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
        <div className="flex items-center gap-3 mb-8" data-id="element-411">
          <div className="w-12 h-12 rounded-full bg-vita-orange-pale flex items-center justify-center flex-shrink-0" data-id="element-412">
            <AlertCircleIcon className="w-6 h-6 text-vita-orange" data-id="element-413" />
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep" data-id="element-414">
            Medizinischer Hinweis & Haftungsausschluss
          </h1>
        </div>

        <div className="space-y-10 text-vita-text-muted leading-relaxed" data-id="element-415">
          <div className="bg-vita-orange-pale/40 rounded-softer p-6 md:p-8 border border-vita-orange-pale" data-id="element-416">
            <h2 className="font-heading text-lg font-bold text-vita-orange mb-3" data-id="element-417">
              Allgemeiner Hinweis
            </h2>
            <p data-id="element-418">
              Die Inhalte dieser Website dienen ausschließlich der allgemeinen
              Information und Bildung. Sie ersetzen in keinem Fall eine
              professionelle medizinische Beratung, Diagnose oder Behandlung.
              Wende dich bei gesundheitlichen Fragen oder Beschwerden immer an
              eine qualifizierte Ärztin oder einen qualifizierten Arzt.
            </p>
          </div>

          <div data-id="element-419">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-420">
              Keine medizinische Beratung
            </h2>
            <p data-id="element-421">
              VitaFrukt ist kein medizinischer Dienstleister und bietet keine
              medizinische Beratung an. Die auf dieser Website veröffentlichten
              Artikel, Tipps und Informationen sind allgemeiner Natur und
              berücksichtigen nicht die individuellen Umstände einzelner
              Personen. Sie sollen dazu beitragen, ein besseres Verständnis für
              Gesundheitsthemen zu entwickeln – nicht, um Diagnosen zu stellen
              oder Behandlungen zu empfehlen.
            </p>
          </div>

          <div data-id="element-422">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-423">
              Eigenverantwortung
            </h2>
            <p data-id="element-424">
              Jede Entscheidung, die du auf Grundlage der hier bereitgestellten
              Informationen triffst, liegt in deiner eigenen Verantwortung.
              Bevor du Änderungen an deiner Ernährung, deinem Lebensstil oder
              deiner Gesundheitsroutine vornimmst, empfehlen wir dir,
              Rücksprache mit einer medizinischen Fachperson zu halten. Dies
              gilt insbesondere bei bestehenden Erkrankungen, Schwangerschaft,
              Stillzeit oder der Einnahme von Medikamenten.
            </p>
          </div>

          <div data-id="element-425">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-426">
              Quellen und Sorgfalt
            </h2>
            <p data-id="element-427">
              Wir bemühen uns, alle Inhalte sorgfältig zu recherchieren und auf
              dem aktuellen Stand der Wissenschaft zu halten. Dennoch können wir
              keine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität
              der bereitgestellten Informationen übernehmen. Wissenschaftliche
              Erkenntnisse entwickeln sich stetig weiter, und Empfehlungen
              können sich ändern.
            </p>
          </div>

          <div data-id="element-428">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-429">
              Haftungsbeschränkung
            </h2>
            <p data-id="element-430">
              VitaFrukt haftet nicht für Schäden, die durch die Nutzung oder
              Nichtnutzung der auf dieser Website bereitgestellten Informationen
              entstehen. Dies gilt auch für Schäden, die durch die Nutzung
              fehlerhafter oder unvollständiger Informationen verursacht werden,
              sofern kein nachweislich vorsätzliches oder grob fahrlässiges
              Verschulden vorliegt.
            </p>
          </div>

          <div data-id="element-431">
            <h2 className="font-heading text-xl font-bold text-vita-text mb-3" data-id="element-432">
              Externe Links
            </h2>
            <p data-id="element-433">
              Unsere Website kann Links zu externen Websites enthalten. Auf den
              Inhalt dieser externen Seiten haben wir keinen Einfluss und
              übernehmen daher keine Gewähr. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber
              verantwortlich.
            </p>
          </div>

          <div className="pt-6 border-t border-vita-border text-sm text-vita-text-light" data-id="element-434">
            <p data-id="element-435">
              Stand: März 2026. Bei Fragen zu diesem Hinweis kannst du uns unter
              info@vitafrukt.de kontaktieren.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}